<template>
  <div id="radiationTherapyFormContent" class="flex layout-column pa-1" style="overflow-y: auto;">
    <div>
      <lx-expansion-panels :single-open="false" v-model="panel">

        <!--   Melder  (panel 0)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(0, 'report_header')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-account-edit"
                                     :isMedicalCommunity="isMedicalCommunity"
                                     :main-headline="$t('FORMS_DIVERSE.REPORTER_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.REPORTER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="report_header">
              <div class="pa-4 layout-row layout-wrap">
                <melder path="report_header"
                        :isDisabled="isFormDisabled()"
                        :validationRef="validationRef"
                        :isMedicalCommunity="isMedicalCommunity"
                        v-model="model.report_header"
                        :additionalItemsList="additionalItemsList"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></melder>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Grunddaten + Strahlentherapie   (panel 1)-->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(1, 'base')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-react"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_RADIATION_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_RADIATION_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="base">
              <div class="pa-4 layout-row layout-wrap">
                <base-data path="base"
                           :key="'BaseDataRadiationTherapy' + model._id"
                           :patientId="patientId"
                           pathRadiation="bestrahlung"
                           :isDisabled="isFormDisabled()"
                           :validationRef="validationRef"
                           v-model="model"
                           :id="model._id"
                           :isLoading="isLoading"
                           :reloadUnlinkedTherapies="reloadUnlinkedTherapies"
                           :reportHeader="model.report_header"
                           @trigger-get-data="getData(model._id, true)"
                           class="layout-row layout-wrap flex-gt-sm-100 flex-100"></base-data>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Nebenwirkungen   (panel 2)  -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(2, 'st_nebenwirkung')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_CTCAE_HEADER')"
                                     icon="mdi-emoticon-sick"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_CTCAE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="st_nebenwirkung">
              <div class="px-4 py-2 layout-row layout-wrap">
                <nebenwirkungen path="st_nebenwirkung"
                                :addCtcaeItem="addItem"
                                :deleteCtcaeItem="deleteItem"
                                :isDisabled="isFormDisabled()"
                                :isRequired="true"
                                v-model="model.st_nebenwirkung"
                                :validationRef="validationRef"
                                class="layout-row layout-wrap flex-gt-sm-100 flex-100"></nebenwirkungen>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Allgemein   (panel 3) -->

        <lx-expansion-panel>
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_COMMON_HEADER')"
                                     icon="mdi-phone-classic"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_COMMON_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content>
            <div class="px-4 pt-4 layout-row layout-wrap">
              <modul-allgemein path="modul_allgemein"
                               :isDisabled="isFormDisabled()"
                               :validationRef="validationRef"
                               v-model="model.modul_allgemein"
                               class="layout-wrap flex-gt-sm-100 flex-100"></modul-allgemein>
            </div>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Anmerkung   (panel 4) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(5, 'anmerkung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.ANNOTATION_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.ANNOTATION_SUB_LINE')"
                                     icon="mdi-lead-pencil">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="anmerkung">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <anmerkung path="anmerkung"
                           :isDisabled="isFormDisabled()"
                           v-model="model.anmerkung"
                           class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>
      </lx-expansion-panels>
   </div>
  </div>
</template>

<script>
import baseData from '../shared/GrunddatenStrahlentherapie'
import nebenwirkungen from '../shared/Nebenwirkungen'
import modulAllgemein from '../shared/ModulAllgemein'
import anmerkung from '../shared/Anmerkung'
import melder from '../shared/Melder'

import utils from '../../../common/utils'
import lodash from 'lodash'

export default {
  name: 'RadiationTherapy',
  mixins: [utils],
  components: {
    baseData,
    nebenwirkungen,
    modulAllgemein,
    anmerkung,
    melder
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    getData: {
      type: Function
    },
    modulesAreEmpty: {
      type: Object,
      default: () => ({})
    },
    // is used to mark headers of invalid modules after trying to complete form (function in utils)
    setIsCompletedIsTriggered: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String
    },
    reloadUnlinkedTherapies: {
      type: Boolean,
      default: false
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    formId: {
      type: String
    },
    isLoading: Boolean
  },
  data () {
    return {
      model: {
        key: 'radiationtherapy'
      },
      panel: []
    }
  },
  created () {
    this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)
  },
  computed: {
    isMedicalCommunity () {
      const user = this.authStore.getters.getAuthUserData && this.authStore.getters.getAuthUserData.user ? this.authStore.getters.getAuthUserData.user : {}
      return user.cancer_form_details && user.cancer_form_details.isMedicalCommunity
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          // scroll to top, if new form
          if (!this.formId) {
            const myDiv = document.getElementById('radiationTherapyFormContent')
            if (myDiv) {
              myDiv.scrollTop = 0
            }
          }
        }
      },
      immediate: true
    },
    'model.base.st_ende_therapie': {
      handler: function (newValue) {
        // set report reason and values of side effects only after changing value and form is not disabled
        if (newValue && !this.isFormDisabled()) {
          this.model.report_header = this.model.report_header || {}
          this.model.report_header.meldeanlass = ''

          // if st_beginn_datum then behandlungsbeginn
          if (newValue === 'N') {
            this.model.report_header.meldeanlass = 'behandlungsbeginn'

            // set default value to side effects, if new form
            if (!this.model._id) {
              this.$set(this.model.st_nebenwirkung, 'grad_maximal_2_oder_unbekannt', 'U')
              // open module of side effects if reason for ending is A (termination due to side effects)
              if (this.panel.indexOf(2) === -1) {
                this.panel.push(2)
              }
            }
          }

          // if st_ende_datum then behandlungsende
          if (newValue === 'J') {
            this.model.report_header.meldeanlass = 'behandlungsende'
          }
        }
      },
      immediate: true
    },
    'modulesAreEmpty.modules': {
      handler: function () {
        this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)

        const self = this
        Object.keys(this.modulesAreEmpty.modules).forEach(key => {
          // push index of filled modules in panel (selected modules are not opened via default)
          if (!self.modulesAreEmpty.modules[key].value && self.panel.indexOf(self.modulesAreEmpty.modules[key].index) < 0) {
            this.$nextTick(() => {
              self.panel.push(self.modulesAreEmpty.modules[key].index)
            })
          }
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

